import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { PageNotFoundComponent } from './core/components/page-not-found/page-not-found.component';
import { UnauthorizedComponent } from './core/components/unauthorized/unauthorized.component';

const routes: Routes = [
  {
    path: 'landing',
    loadChildren: (): any =>
      import('../app/modules/landing/landing.module').then((m) => m.LandingModule),
  },
  {
    path: 'badminton-tournament',
    loadChildren: (): any =>
      import('../app/modules/badminton-tournament/badminton-tournament.module').then(
        (m) => m.BadmintonTournamentModule
      ),
  },
  {
    path: 'badminton-queueing-system',
    loadChildren: (): any =>
      import('../app/modules/badminton-queueing-system/badminton-queueing-system.module').then(
        (m) => m.BadmintonQueueingSystemModule
      ),
  },
  {
    path: 'badminton-rating-system',
    loadChildren: (): any =>
      import('../app/modules/badminton-rating-system/badminton-rating-system.module').then(
        (m) => m.BadmintonRatingSystemModule
      ),
  },
  {
    path: 'auth',
    loadChildren: (): any => import('../app/modules/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'event',
    loadChildren: (): any => import('../app/modules/event/event.module').then((m) => m.EventModule),
  },
  {
    path: 'game',
    loadChildren: (): any => import('../app/modules/game/game.module').then((m) => m.GameModule),
  },
  {
    path: 'queue',
    loadChildren: (): any => import('../app/modules/queue/queue.module').then((m) => m.QueueModule),
  },
  {
    path: 'info',
    loadChildren: (): any => import('../app/modules/info/info.module').then((m) => m.InfoModule),
  },
  {
    path: 'group',
    loadChildren: (): any => import('../app/modules/group/group.module').then((m) => m.GroupModule),
  },
  {
    path: 'app',
    loadChildren: (): any => import('../app/modules/home/home.module').then((m) => m.HomeModule),
  },
  {
    path: 'legal',
    loadChildren: (): any => import('../app/modules/legal/legal.module').then((m) => m.LegalModule),
  },
  {
    path: 'subscription',
    loadChildren: (): any =>
      import('../app/modules/subscription/subscription.module').then((m) => m.SubscriptionModule),
  },
  {
    path: 'sponsorship',
    loadChildren: (): any =>
      import('../app/modules/sponsorship/sponsorship.module').then((m) => m.SponsorshipModule),
  },
  {
    path: 'badminton-profile',
    loadChildren: (): any =>
      import('../app/modules/badminton-profile/badminton-profile.module').then(
        (m) => m.BadmintonProfileModule
      ),
  },
  {
    path: '',
    redirectTo: '/landing',
    pathMatch: 'full',
  },
  {
    path: 'page-not-found',
    component: PageNotFoundComponent,
  },
  {
    path: 'unauthorized',
    component: UnauthorizedComponent,
  },
  {
    path: '**',
    redirectTo: 'page-not-found',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
